// @flow
import * as React from 'react';
import Radium from 'radium';
import { compose, withState } from 'recompose';
import {
  Card,
  CardHeader,
  CardBlock,
  FormGroup,
  Button,
  Input,
} from 'reactstrap';

type Props = {
  type: string,
  onDelete: (reason: string) => void,

  // recompose
  reason: string,
  onReasonChange: (reason: string) => void,
};

class EmergencyBreak extends React.Component<Props> {
  _onPullBreak = () => {
    const { onDelete, reason } = this.props;
    onDelete(reason);
  };

  render() {
    const { reason, onReasonChange, type } = this.props;

    return (
      <Card style={styles.root}>
        <CardHeader style={styles.title}>Notbremse ziehen</CardHeader>
        <CardBlock>
          <FormGroup>
            <Input
              type="textarea"
              placeholder="Warum soll dieser Eintrag gelöscht werden?"
              value={reason}
              onChange={event => onReasonChange(event.target.value)}
            />
          </FormGroup>
          <Button color="danger" disabled={!reason} onClick={this._onPullBreak}>
            {type.toUpperCase()} LÖSCHEN
          </Button>
        </CardBlock>
      </Card>
    );
  }
}

const styles = {
  root: {
    width: '100%',
  },
  title: {
    fontWeight: 'bold',
  },
};

const EmergencyBreakContainer = compose(
  withState('reason', 'onReasonChange', ''),
  Radium
)(EmergencyBreak);

export default EmergencyBreakContainer;



// WEBPACK FOOTER //
// ./src/components/EmergencyBreak/EmergencyBreak.js